{
  "averageDailyUsage": {
    "title": "Utilisation quotidienne moyenne",
    "unitLabel": "Acre-pouces/jour"
  },
  "downloadWaterUsageReportButton": "Télécharger le rapport",
  "estimatesWarning": {
    "message": "Les données affichées ici proviennent d’estimations historiques et ne doivent pas être utilisées dans les registres officiels.",
    "title": "Affichage des estimations historiques"
  },
  "farmWideWaterUsage": {
    "title": "Utilisation de l'eau à l'échelle de la ferme",
    "unitLabel": "Acre-pieds"
  },
  "flowSourceToggle": {
    "label": "Source des données :"
  },
  "flowSummaryTable": {
    "headings": {
      "peakFlowRate": "Débit de pointe (GPM)",
      "totalVolumeAcreFeet": "Volume total (pieds carrés)"
    },
    "title": "Résumé de l'utilisation de l'eau à la ferme"
  },
  "flowTimeseries": {
    "axisLabels": {
      "y": "Volume (acre-pied)"
    },
    "title": "Utilisation au fil du temps"
  },
  "highestFlowRate": {
    "pumpWithDeviceName": "Pompe : {{deviceName}}",
    "title": "Débit le plus élevé",
    "unitLabel": "Gallons/minute"
  },
  "noDataFound": "Aucune donnée trouvée pour les filtres spécifiés",
  "peakDailyUsage": {
    "onWithDate": "Le {{date, datetime}}",
    "title": "Utilisation quotidienne maximale",
    "unitLabel": "Acre-pouces"
  },
  "pumpFlowStackedTimeseries": {
    "axisLabels": {
      "y": "Volume (acres pieds)"
    },
    "title": "Volume total au fil du temps"
  },
  "pumpTotalHorizontalBar": {
    "axisLabels": {
      "x": "Volume (acre-pied)"
    },
    "title": "Volume total par pompe"
  },
  "title": "Analyse de flux"
}
